module.exports = __webpack_public_path__ + "images/emoji/jeans.da64039e56438f50bb8f.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/jeans.png
// module id = 1dI7
// module chunks = 24